<template>
  <v-col cols="12" md="6" class="asc-mxrec-validation-wrapper form-wrapper">
    <h3 class="subtitle">Validation</h3>
    <asc-autocomplete-selector
      v-model="getFixEffectiveness"
      :disabled="reEntrantLock"
      :items="fixEffectivenessOptions"
      label="Fix Effectiveness"
      no-array
      display-clear
      :readonly="isReadOnlyPermissionInvestigate && !isRecommendationTab"
      :sort-items="false"
    />
    <asc-autocomplete-selector
      v-model="getServiceDeliveryOutcome"
      :disabled="reEntrantLock"
      :items="serviceDeliveryOutcomeOptions"
      label="Service Delivery Outcome"
      no-array
      display-clear
      :readonly="isReadOnlyPermissionInvestigate && !isRecommendationTab"
      :sort-items="false"
    />
    <asc-autocomplete-selector
      v-model="getAnalyticDetectionOutcome"
      :disabled="reEntrantLock"
      :items="analyticDetectionOutcomeOptions"
      label="Analytic Detection Outcome"
      no-array
      display-clear
      :readonly="isReadOnlyPermissionInvestigate && !isRecommendationTab"
      :sort-items="false"
    />
    <asc-text-field-input
      v-model="getExpectedServiceInterruptionMinutesSaved"
      label="Expected Service Interruption Minutes Saved"
      hide-details
      :disabled="reEntrantLock"
      :max-length="textFieldMaxLength"
      :readonly="isReadOnlyPermissionInvestigate && !isRecommendationTab"
    />
  </v-col>
</template>

<script>
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'
import {
  AscMxRecPropsMixin,
  AscMxRecPermissionMixin,
} from '@/components/mixins'
import AscAutocompleteSelector from '@/components/molecules/AscAutocompleteSelector'

export default {
  name: 'AscMxRecValidationWrapper',
  components: {
    AscAutocompleteSelector,
    AscTextFieldInput,
  },
  mixins: [AscMxRecPropsMixin, AscMxRecPermissionMixin],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    fixEffectivenessOptions: {
      type: Array,
      default: () => [],
    },
    serviceDeliveryOutcomeOptions: {
      type: Array,
      default: () => [],
    },
    analyticDetectionOutcomeOptions: {
      type: Array,
      default: () => [],
    },
    reEntrantLock: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      textFieldMaxLength: 100,
    }
  },

  computed: {
    getFixEffectiveness: {
      get() {
        return this.data.fixEffectivenessId
      },
      set(val) {
        this.emitChangeEvent({
          fixEffectivenessId: val,
        })
      },
    },
    getServiceDeliveryOutcome: {
      get() {
        return this.data.serviceDeliveryOutcomeId
      },
      set(val) {
        this.emitChangeEvent({
          serviceDeliveryOutcomeId: val,
        })
      },
    },
    getAnalyticDetectionOutcome: {
      get() {
        return this.data.analyticDetectionOutcomeId
      },
      set(val) {
        this.emitChangeEvent({
          analyticDetectionOutcomeId: val,
        })
      },
    },
    getExpectedServiceInterruptionMinutesSaved: {
      get() {
        return this.data.expectedServiceInterruptionMinutesSaved
      },
      set(val) {
        this.emitChangeEvent({
          expectedServiceInterruptionMinutesSaved: val,
        })
      },
    },
  },

  methods: {
    emitChangeEvent(propToOverwrite) {
      const mergedInfo = {
        ...this.data,
        ...propToOverwrite,
      }
      this.$emit('updateValidationInfo', mergedInfo)
    },
  },
}
</script>

<style lang="scss">
.asc-mxrec-validation-wrapper {
  display: flex;
  flex-direction: column;

  &.form-wrapper {
    .asc-autocomplete-selector {
      margin-bottom: 21px;

      .asc-base-selector--label {
        height: 12px;
        margin-top: 4px;

        .asc-required-label {
          line-height: 12px;
        }
      }

      .asc-base-selector--input-container {
        height: 32px !important;
        padding: 8px 0 8px;
        align-items: center;

        .asc-base-selector--input {
          height: 24px;
        }
      }
    }
  }

  .subtitle {
    font-size: $font-size-md;
    line-height: $line-height-md;
    color: $primary-black;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 29px;
  }
}
</style>
